import mainHTTPClient from '../clients/mainHTTPClient'
import { MAIN_HTTP_API_ENDPOINTS } from '../constants/api/mainHttp'

/**
 * Search for deviceModelOutputs.
 * @param listMetaData {ListMetaData}
 * @returns {Promise<AxiosResponse<object[]>>}
 * @constructor
 */
const FindMany = listMetaData => mainHTTPClient.get(
  MAIN_HTTP_API_ENDPOINTS.DEVICE_MODEL_OUTPUTS,
  {
    ...listMetaData.toAxiosRequestParams()
  }
)

const DeviceModelOutputService = {
  FindMany
}

export default DeviceModelOutputService
